import React from 'react';
import "./CommissionSelector.css"
import CommissionEntry from "./CommissionEntry";
import { padCalendar } from "../../util";
//import { Link } from "react-router-dom";

const CommissionSelector = (props) => (
	<React.Fragment>
		<div id={"commission-selector-title-holder"}>
			<div className={"commission-selector-title"}>Commission Selector</div>
{/*            <Link to={"/commissions/create"}><button id={"commission-create-commission-button"}>Commission Custom Severity Report</button></Link> */}
		</div>
		<table className={"commission-selector-table"}>
			<thead>
				<tr className={"commission-selector-headers"}>
					<th className={"commission-selector-header"} style={{ "float": "left" }}>Commission Name</th>
					<th className={"commission-selector-header"}>Class Period Start Date</th>
					<th className={"commission-selector-header"}>Class Period End Date</th>
					<th className={"commission-selector-header"}>Commission Date</th>
					<th className={"commission-selector-header"}>Ticker</th>
					<th className={"commission-selector-header"}>Status</th>
				</tr>
			</thead>
			<tbody>
				{props.commissions&&props.commissions.map((commission,index) =>
			   
				<CommissionEntry
					className={commission.caseId===null?"commission-selector-entrynull":"commission-selector-entry"}
					key={index}
					commission_name={commission.commissionName}
					class_period_start={padCalendar(commission.classPeriodStart)}
					class_period_end={padCalendar(commission.classPeriodEnd)}
					date_commissioned={padCalendar(commission.dateCommissioned)}
					cusip={commission.symbol}
					commission_id={commission.id}
					onClick={() => commission.caseId!==null&&props.onCommissionClick(commission)}
					status={commission.status}
				/>)
				}
			</tbody>
		</table>
	</React.Fragment>
);


export default CommissionSelector;


// WEBPACK FOOTER //
// ./src/commissions/components/CommissionSelector.js